import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0005ce22"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { key: 3 }
const _hoisted_6 = {
  key: 0,
  class: "error"
}

import { computed, ref } from 'vue';
import { subscribe } from '@/api/subscriptions';
import { useConfetti } from '@/composables/confetti';
import { useDates } from '@/composables/dates';
import { useSignup } from '@/composables/signup';
import { transformError } from '@/lib/claimUtil';
import { useClaimStore } from '@/store/claimStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'JoinButton',
  setup(__props) {

const store = useClaimStore();
const { addConfetti } = useConfetti();

const incomplete = computed(() => {
  return (
    store.flatRequirements.some((requirement) => requirement && !requirement.complete) ||
    store.emailRequirements.some((requirement) => requirement && !requirement.complete)
  );
});
const twitterIncomplete = computed(() => {
  return (
    store.twitterRequirements && store.twitterRequirements.length > 0 && !store.twitterUsername
  );
});

const { claimStartDate, claimEndDate, getCalendarString } = useDates();
const signupError = ref();
const { signup } = useSignup({
  onSuccess: () => {
    addConfetti();
  },
  onError: (error: any) => {
    signupError.value = transformError(error) || 'Unable to join giveaway';
  },
});

const storedEmail = computed(() => {
  const emailRequirement = store.emailRequirements.find(
    (requirement) => requirement.type === 'email'
  );
  const requirementEmail = emailRequirement?.userData?.email;
  return requirementEmail;
});
const joinGiveaway = async () => {
  signup(undefined, {});
  if (store.subscribed) {
    await subscribe(store.creator.address, storedEmail.value);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _mergeProps({ class: "campaign-join" }, _ctx.$attrs), [
    _createElementVNode("button", {
      onClick: joinGiveaway,
      id: "join-button",
      class: "campaign-join-button",
      disabled: _unref(store).disabled || incomplete.value || twitterIncomplete.value,
      "data-testid": "buy-button"
    }, [
      (_unref(store).status === 'not-started')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Drops " + _toDisplayString(_unref(getCalendarString)(_unref(claimStartDate))), 1))
        : (_unref(store).status === 'ended')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Ended " + _toDisplayString(_unref(getCalendarString)(_unref(claimEndDate))), 1))
          : (_unref(store).isSoldOut)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Sold out"))
            : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString('Join Giveaway')))
    ], 8, _hoisted_1),
    (signupError.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(signupError.value?.error || signupError.value), 1))
      : _createCommentVNode("", true)
  ], 16))
}
}

})